import { Amount, DataRoom, Deal, Issuer } from '../../deals/redux/types';

const InvestmentTypes = {
    FETCH_REPAYMENT_REQ: 'FETCH_REPAYMENT_REQ',
    SET_REPAYMENT: 'SET_REPAYMENT',
    //Investments
    GET_INVESTMENTS_REQ: 'GET_INVESTMENTS_REQ',
    SET_INVESTMENTS: 'SET_INVESTMENTS',
    //Investment Details
    FETCH_INVESTMENT_DETAILS: 'FETCH_INVESTMENT_DETAILS',
    SET_INVESTMENT_DETAILS: 'SET_INVESTMENT_DETAILS',
    //ExecutedAgreements
    FETCH_EXECUTED_AGREEMENTS: 'FETCH_EXECUTED_AGREEMENTS',
    SET_EXECUTED_AGREEMENTS: 'SET_EXECUTED_AGREEMENTS',
    //Updates
    FETCH_UPDATED_OR_REPORTIES: 'FETCH_UPDATED_OR_REPORTIES',
    SET_UPDATED_OR_REPORTIES: 'SET_UPDATED_OR_REPORTIES',
    //Performaces
    FETCH_PERFORMANCES: 'FETCH_PERFORMANCES',
    SET_PERFORMANCES: 'SET_PERFORMANCES',
    //Distribution
    FETCH_DISTRIBUTION: 'FETCH_DISTRIBUTION',
    SET_DISTRIBUTION: 'SET_DISTRIBUTION',
    //PPM
    FETCH_PPM: 'FETCH_PPM',
    SET_PPM: 'SET_PPM',
    //Reporting Obligation
    FETCH_REPORTING_OBLIGATION: 'FETCH_REPORTING_OBLIGATION',
    SET_REPORTING_OBLIGATION: 'SET_REPORTING_OBLIGATION',
    //Cashflow
    FETCH_CASHFLOW: 'FETCH_CASHFLOW',
    SET_CASHFLOW: 'SET_CASHFLOW',
    //Guarantees
    FETCH_GUARANTEES: 'FETCH_GUARANTEES',
    SET_GUARANTEES: 'SET_GUARANTEES',
    //securities
    FETCH_SECURITIES: 'FETCH_SECURITIES',
    SET_SECURITIES: 'SET_SECURITIES',
    //Covenants
    FETCH_COVENANTS: 'FETCH_COVENANTS',
    SET_COVENANTS: 'SET_COVENANTS',
    //aggregate
    FETCH_AGGREGATE: 'FETCH_AGGREGATE',
    SET_AGGREGATE: 'SET_AGGREGATE',
    //Updated documents
    FETCH_UPDATE_DOCUMENTS: 'FETCH_UPDATE_DOCUMENTS',
    SET_UPDATE_DOCUMENTS: 'SET_UPDATE_DOCUMENTS',
    //Executed Agreements
    FETCH_INVESTMENT_EXECUTED_AGREEMENTS: 'FETCH_INVESTMENT_EXECUTED_AGREEMENTS',
    SET_INVESTMENT_EXECUTED_AGREEMENTS: 'SET_INVESTMENT_EXECUTED_AGREEMENTS',
};

export default InvestmentTypes;

export interface Audit {
    event: string;
    updatedAt: string;
    updatedBy?: string;
}

export interface InvestmentDoc {
    title: string;
    url: string;
}

export interface Investment {
    amount: Amount;
    dealUUID: string;
    investorUUID: string;
    status: string;
    uuid: string;
    paymentReceipts: InvestmentDoc[];
    documents: InvestmentDoc[];
    audit?: Audit;
}

export interface Distribution {
    amount?: Amount;
    audit?: Audit;
    month: number;
    uuid: string;
    year: number;
}

export interface Redemptions {
    amount?: Amount;
    audit?: Audit;
    date?: {
        date: string;
    };
    uuid: string;
}

export interface InvestmentDetails {
    amount?: Amount;
    audit?: Audit;
    bookingUUID?: string;
    creationAudit?: Audit;
    deal?: Deal;
    dealUUID: string;
    documents?: InvestmentDoc[];
    booking?: Booking;
    derived?: Derived;
    investmentDate?: {
        date?: {
            date: string;
        };
    };
    fundInvestmentInfo?: {
        distributions?: Distribution[];
        redemptions?: Redemptions[];
        performanceStartDate?: {
            month: number;
            year: number;
        };
        subscriptionDate?: {
            date: string;
        };
        balanceAmount?: Amount;
        redeemedAmount?: Amount;
    };
    investorUUID: string;
    issuer?: Issuer;
    paymentReceipts?: InvestmentDoc[];
    status: string;
    uuid: string;
}
export interface RepayemtRemark {
    time: string;
    comment: string;
}

export interface RepaymentInfo {
    dealRepayment: {
        actualAmount: Amount;
        currency: string;
        date: {
            date: string;
        };
        remarks?: RepayemtRemark[];
        expectedAmount: Amount;
        status: string;
        uuid: string;
    };
    investmentRepayment: {
        actualAmount: Amount;
        dealRepaymentUUID: string;
        expectedAmount: Amount;
        uuid: string;
        fee: Amount;
        remarks?: RepayemtRemark[];
    };
}

export interface Booking {
    uuid: string;
    generalTerms?: {
        maturityDate?: {
            date: string;
        };
        amount?: Amount;
        startDate?: {
            date: string;
        };
    };
    interest?: {
        interestRate: number;
    };
    status: string;
}

export interface Derived {
    maturityDate?: {
        date: string;
    };
    outstandingPrincipal?: Amount;
    interestRate: string;
    totalDistribution?: Amount;
    status: string;
}
export interface Investments {
    issuerName?: string;
    dealName?: string;
    instrumentType?: string;
    investmentAmount?: Amount;
    investmentDate?: string;
    interestRates?: {
        ccy: string;
        interestRate: string;
    }[];
    dealType?: string;
    status?: string;
    dealUUID?: string;
    uuid: string;
    booking?: Booking;
    derived?: Derived;
    totalDistribution?: Amount;
    interestRate?: string;
    outstandingPrincipal?: Amount;
    maturityDate?: string;
}

export interface Repayment {
    deal: {
        dealType: string;
        instrumentType: string;
        terms?: {
            distribution: string;
            tenorInMonths: number;
            equityFundingToDate?: Amount;
            fundingRound?: string;
            interestRates?: {
                ccy: string;
                interestRate: string;
            }[];
        };
        title: string;
        uuid: string;
    };
    issuer: Issuer;
    investment: Investment;
    repayments?: RepaymentInfo[];
    executedAgreements: DataRoom[];
    updates: DataRoom[];
}

export interface performance {
    audit: Audit;
    benchmarkAudit: Audit;
    benchmarkCRate: number;
    benchmarkRate: number;
    month: number;
    cRate: number;
    rate: number;
    year: number;
}

export interface Performances {
    effectiveDate?: {
        date: string;
    };
    benchmarkName: string;
    lastUpdatedOn: string;
    performanceStart?: {
        month: number;
        year: number;
    };
    performances: performance[];
    subscriptionDate?: {
        date: string;
    };
}

export interface PPM {
    investorUUID?: string;
    ppmNumber: number;
    ppmUrl: string;
    timestamp: string;
}

export interface ReportingObligationDoc {
    audit: Audit;
    issuerUUID: string;
    obligationDate?: {
        date: string;
    };
    obligationType: string;
    title: string;
    url: string;
    uuid: string;
    status: string;
    comment?: string;
}

export interface Reporting {
    amountBorrowed?: Amount;
    bookingUUID: string;
    frequency: string;
    interestRate: number;
    maturityDate?: {
        date: string;
    };
    obligationType?: string;
    uploadDetails?: ReportingObligationDoc[];
}

export interface ReportingObligation {
    obligationDate?: {
        date: string;
    };
    reports: Reporting[];
}

export interface UpdatePortfolioDoc {
    obligationDate?: {
        date: string;
    };
    reports: Reporting[];
    investmentUUID: string;
    dealUUID?: string;
    issuerUUID?: string;
    issuerName?: string;
}

export interface PaymentReceipt {
    title: string;
    url: string;
}

export interface RepaymentRemark {
    time?: string;
    comment: string;
}

export interface Cashflow {
    uuid?: string;
    type?: 'Booking' | 'Investment';
    typeUUID: string;
    paymentDate: {
        date: string;
    };
    interestPayment?: Amount;
    principalRepayment?: Amount;
    principalOutstanding?: Amount;
    totalAmount?: Amount;
    netPayment?: Amount;
    managementFee?: Amount;
    totalHSFee?: Amount;
    paymentReceipts?: PaymentReceipt[];
    audit?: Audit;
    remarks?: RepaymentRemark[];
}

export const InvestmentStatus = {
    interested: 'Interested',
    pendingPaymentReceipt: 'Pending PaymentReceipt',
    cancelled: 'Cancelled',
    pendingPaymentConfirmation: 'Pending PaymentConfirmation',
    paymentReceived: 'PaymentReceived',
    invested: 'Invested',
    repaid: 'Repaid',
    redeemed: 'Redeemed',
};

export interface Guarantees {
    guaranteeType: string;
    guarantorLegalName: string;
    description?: string;
    uuid: string;
}

export interface Security {
    securityType: string;
    rank: string;
    typeOfAsset: string;
    collateralization: string;
    collateralizationType?: string;
    assetOwner: string;
    uuid: string;
    description?: string;
}

export interface FinancialCovenant {
    financialCovenant: string;
    valueType?: 'Percentage' | 'Number' | 'Month';
    value?: number;
    frequency: number;
    rule: string;
    uuid: string;
    assignee?: string;
    description?: string;
}

export interface AggregateOutStandingDeal {
    totalDebtOutstanding: Amount;
    totalFundOutstanding: Amount;
    totalEquityOutstanding: Amount;
    totalOutstanding: Amount;
}

export interface AggregateInvestedDeal {
    totalDebtInvested: Amount;
    totalFundInvested: Amount;
    totalEquityInvested: Amount;
    totalInvested: Amount;
}

export interface Aggregate {
    outstanding?: {
        deal?: AggregateOutStandingDeal;
        currency?: any;
        geography?: any;
    };
    invested?: {
        deal?: AggregateInvestedDeal;
        currency?: any;
        geography?: any;
    };
}

export interface InvestmentFilters {
    dealName: string[];
    issuerName: string[];
    dealType: string[];
    instrumentType: string[];
    status: string[];
    interestRate: string[];
}

export interface ExecutedAgreements {
    audit: Audit;
    bookingUUID: string;
    documentType: String;
    issuerUUID: string;
    title: string;
    url: string;
    uuid: string;
    issuerName?: string;
    dealUUID?: string;
    dealName?: string;
    dealDocParentUUID?: string;
}

export interface InvestmentState {
    investments: Investments[];
    loading: boolean;
    repayments: RepaymentInfo[];
    repayment: Repayment | undefined;

    investmentDetails?: InvestmentDetails;
    detailLoading: boolean;

    executedAgreements?: DataRoom[];
    updates?: DataRoom[];
    executedAgreementsLoading: boolean;
    updatesLoading: boolean;

    performances?: Performances;
    performancesLoading: boolean;

    distributions?: {
        distributions?: Distribution[];
        lastUpdatedOn: string;
    };
    distributionLoading: boolean;
    ppm?: PPM;

    reportingObligations: ReportingObligation[];
    rLoading: boolean;

    cashflow: Cashflow[];
    cLoading: boolean;

    guarantees: Guarantees[];
    gLoading: boolean;

    security: Security[];
    sLoading: boolean;

    covenant: FinancialCovenant[];
    coLoading: boolean;

    aggregate?: Aggregate;
    aLoading: boolean;
    filterData: InvestmentFilters;

    updatePortfolioDoc: UpdatePortfolioDoc[];
    loadingUpdate: boolean;

    executedAgreementsDoc: ExecutedAgreements[];
    eloading: boolean;
}
